import { useQuery, gql } from '@apollo/client'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface SofaFormTypeSelectProps {
  field: any
}

export const GET_SOFA_TYPES = gql`
  query {
    __type(name: "SofaFormType") {
      name
      enumValues {
        name
        isDeprecated
      }
    }
  }
`

const SofaFormTypeSelect: React.FC<SofaFormTypeSelectProps> = ({ field }) => {
  const { data, loading, error } = useQuery(GET_SOFA_TYPES)

  if (loading) return <div>Loading...</div>
  if (error) return <div>Error loading fabric types</div>

  const fabricTypes = data?.__type?.enumValues || []

  return (
    <Select onValueChange={field.onChange} value={field.value}>
      <SelectTrigger>
        <SelectValue placeholder="Select a module type" />
      </SelectTrigger>
      <SelectContent>
        {[...fabricTypes]
          .sort((a: any, b: any) => a.name?.localeCompare(b.name))
          .map((type: any) => (
            <SelectItem key={type.name} value={type.name}>
              {type.name}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  )
}

export default SofaFormTypeSelect
